module.exports = __webpack_public_path__ + "um.svg?c9446ffe60fa119248647b4d39b3c052";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/um.svg
// module id = 1407
// module chunks = 27